import axios from "~/plugins/axios";

export default {
  fetchConfiguredByGlobal(
    automationInterfaceId,
    include = [
      "search",
      "extending_searches",
      "global_automation",
      "email_account",
      "email_template",
      "search_thumbnail",
    ],
  ) {
    return axios
      .get(`/web_api/v1/automation_interface/configured/global/${automationInterfaceId}`, {
        params: {
          include,
        },
      })
      .then((response) => response.data);
  },
  fetchConfigured(
    automationInterfaceId,
    include = [
      "search",
      "extending_searches",
      "email_account",
      "email_template",
      "search_thumbnail",
    ],
  ) {
    return axios
      .get(`/web_api/v1/automation_interface/configured/${automationInterfaceId}`, {
        params: {
          include,
        },
      })
      .then((response) => response.data);
  },
  getPendingConfirmation(includes = []) {
    return axios.get("/web_api/v1/automation_interface/pending_confirmation", {
      params: {
        includes,
      },
    })
      .then((response) => response.data);
  },
  getPendingConfirmationCount() {
    return axios.get("/web_api/v1/automation_interface/pending_confirmation_count")
      .then((response) => response.data.data.count);
  },
};
